module.exports = __webpack_public_path__ + "img/emprendedores.c8c664eb.png";